import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ProjectResultsPageTemplate } from "senf-atomic-design-system";

const ProjectResultsPage = () => {
  const navigate = useNavigate();
  const project = useSelector((state) => state.data.project);

  return (
    <ProjectResultsPageTemplate
      variant="mainApp"
      project={project}
      navigate={navigate}
    />
  );
};

export default ProjectResultsPage;
